import { render, staticRenderFns } from "./FormatHistoryModal.vue?vue&type=template&id=0796f329"
import script from "./FormatHistoryModal.vue?vue&type=script&lang=js"
export * from "./FormatHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./FormatHistoryModal.vue?vue&type=style&index=0&id=0796f329&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports